export default __webpack_public_path__ + "static/media/expl-gradcam_04_EN.651c8c9c.png";